import React from 'react';
import { Users, Eye, Activity, Globe } from 'lucide-react';
import { useSiteStats } from '../hooks/useSiteStats';

function StatBox({ icon: Icon, label, value, color }) {
  return (
    <div
      data-testid={`site-stat-${label.toLowerCase().replace(/\s+/g, '-')}`}
      className="flex-1 min-w-[140px] bg-white border-2 border-[#3a1064] rounded-xl px-3 py-2 shadow-[0_3px_0_#3a1064] flex items-center gap-2.5"
    >
      <div
        className="h-9 w-9 rounded-lg border-2 border-[#3a1064] flex items-center justify-center shrink-0 text-white"
        style={{ background: color }}
      >
        <Icon className="h-4 w-4" strokeWidth={2.5} />
      </div>
      <div className="min-w-0">
        <div className="text-[9px] font-black uppercase tracking-wider text-[#3a1064]/70">{label}</div>
        <div className="font-black text-[#3a1064] text-lg leading-none mt-0.5">{value}</div>
      </div>
    </div>
  );
}

export default function SiteStatsBar() {
  const { stats } = useSiteStats();
  const v = (n) => (typeof n === 'number' ? n.toLocaleString() : '—');

  return (
    <section
      className="max-w-7xl mx-auto px-3 sm:px-6 pb-6"
      data-testid="site-stats-bar"
    >
      <div className="flex items-center gap-2 flex-wrap">
        <StatBox icon={Users}    label="Members"        value={v(stats?.users)}          color="#ff2bd6" />
        <StatBox icon={Globe}    label="Unique Visitors" value={v(stats?.visitors)}      color="#9d3dff" />
        <StatBox icon={Eye}      label="Visitors Today" value={v(stats?.visitors_today)} color="#00b8ff" />
        <StatBox icon={Activity} label="Online Now"     value={v(stats?.online_5m)}      color="#10b981" />
      </div>
    </section>
  );
}
